import React from 'react'
import Box, { BoxProps } from '@mui/material/Box'
import { styled } from '@mui/material/styles'

const NavigationRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  '& .MuiButton-root, & .MuiChip-root': {
    minHeight: 32,
    minWidth: 0,
    padding: '3px 12px',
    borderRadius: 14,
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 1.5,
    whiteSpace: 'nowrap',
  },
  '& .MuiButton-startIcon': { marginLeft: 0, marginRight: 6 },
  '& .MuiButton-endIcon': { marginLeft: 6, marginRight: 0 },
  '& .MuiButton-startIcon > *, & .MuiButton-endIcon > *': { fontSize: 16 },
  '& .MuiChip-label': { padding: 0 },
  '& .MuiChip-icon': {
    marginLeft: 0,
    marginRight: 6,
    fontSize: 16,
    flexShrink: 0,
  },
}))

export default function ViewNavigation({
  className = '',
  ...props
}: BoxProps): JSX.Element {
  return (
    <NavigationRow
      component="nav"
      aria-label="Page navigation"
      justifyContent="space-between"
      mb="10px"
      {...props}
      className={`rt-view-navigation ${className}`}
    />
  )
}
